import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="contact" className="text-center">
      <div className="footer-above">
        <div className="container">
          <div className="row">
            <div className="footer-col">
              <ul className="list-inline">
                <li>
                  <a href="https://www.instagram.com/philwithey" target="_blank" rel="noopener noreferrer" className="btn-social btn-outline">
                    <i className="fa fa-fw fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.soundcloud.com/philwithey" target="_blank" rel="noopener noreferrer" className="btn-social btn-outline">
                    <i className="fa fa-fw fa-soundcloud"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/philwithey" target="_blank" rel="noopener noreferrer" className="btn-social btn-outline">
                    <i className="fa fa-fw fa-facebook"></i>
                  </a>
                </li>
                <li>
                  <a href="https://uk.linkedin.com/in/phil-withey-8424311" target="_blank" rel="noopener noreferrer" className="btn-social btn-outline">
                    <i className="fa fa-fw fa-linkedin"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-below">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              Copyright &copy; Phil Withey {currentYear}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 